import { Play, Pencil, Download, BarChart3 } from "lucide-react";
import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { SourceAction } from "../types";

export interface DBActionsConfig {
  onRerunQuery?: () => void;
  onEditSQL?: () => void;
  onExportCSV?: () => void;
  onGenerateChart?: () => void;
}

export function buildDBActions(cfg: DBActionsConfig, i18n: I18n): SourceAction[] {
  return [
    {
      id: "rerun",
      label: i18n._(msg`Rerun query`),
      icon: <Play className="h-3.5 w-3.5" />,
      variant: "primary",
      disabled: !cfg.onRerunQuery,
      onSelect: () => cfg.onRerunQuery?.(),
    },
    {
      id: "edit-sql",
      label: i18n._(msg`Modifica SQL`),
      icon: <Pencil className="h-3.5 w-3.5" />,
      disabled: !cfg.onEditSQL,
      onSelect: () => cfg.onEditSQL?.(),
    },
    {
      id: "export-csv",
      label: i18n._(msg`Esporta CSV`),
      icon: <Download className="h-3.5 w-3.5" />,
      disabled: !cfg.onExportCSV,
      onSelect: () => cfg.onExportCSV?.(),
    },
    {
      id: "chart",
      label: i18n._(msg`Genera chart`),
      icon: <BarChart3 className="h-3.5 w-3.5" />,
      disabled: !cfg.onGenerateChart,
      onSelect: () => cfg.onGenerateChart?.(),
    },
  ];
}
